import React from 'react';

import {Messages} from 'primereact/messages';
import GeneralDatatable from '../components/GeneralDatatable';

class KeyDatatable extends React.Component {

    constructor(props) {
        super(props);

        this.state={
            keyData: [],
            selectedColumns: [
                {field:'uiY_DUEDATE', header:'Date Due'},
                {field:'uiY_SYSTEM', header:'System'},
                {field:'uiY_FULLCODE', header:'Full Code'},
                {field:'uiY_DESC', header:'Description'},
                {field:'uiY_NOTES', header:'Notes'},  
                {field:'fullname', header:'Associate'},
                {field:'uiY_KEYWAY', header:'Keyway'},
                {field:'hookdesc', header:'Hook Description'}
            ],
            columnWidthTracker: "182.875,182.875,182.875,182.875,182.875,182.875,182.875,182.875",
            defaultOrder: ["uiY_DUEDATE", "uiY_SYSTEM", "uiY_FULLCODE", "uiY_DESC", "uiY_NOTES", "fullname", "uiY_KEYWAY", "hookdesc"],
            isLoading: true
        };
        this.handleWidth = this.handleWidth.bind(this);
        this.handleSelectedColumns = this.handleSelectedColumns.bind(this);
    }


    async componentDidMount() {
        let parsedTableData = JSON.parse(sessionStorage.getItem('keyDatatableTableData'));

        if(parsedTableData!==null) {
            if(parsedTableData.selectedColumns !== null) {
                this.setState({ selectedColumns: parsedTableData.selectedColumns })
            }
        }

        this.setState({ isLoading: false })
    }

    handleWidth(width) {
        this.setState({ columnWidthTracker: width })
    }

    handleSelectedColumns(e) {
        this.setState({ selectedColumns: e })
    }

    render() {
        if(this.props.keyData.length===0) {
            return(<div><h3>This door currently has no keys that can operate the door.</h3></div>);
        } else {
            return(
                <div>
                    <Messages ref={(el) => this.messages = el} />
                    <GeneralDatatable 
                        columnArray = {[
                            {field:'uiY_DUEDATE', header:'Date Due'},
                            {field:'uiY_SYSTEM', header:'System'},
                            {field:'uiY_FULLCODE', header:'Full Code'},
                            {field:'uiY_DESC', header:'Description'},
                            {field:'uiY_NOTES', header:'Notes'},  
                            {field:'fullname', header:'Associate'},
                            {field:'uiY_KEYWAY', header:'Keyway'},
                            {field:'hookdesc', header:'Hook Description'}
                        ]}

                        csvHeaders = {[
                            {key:'uiY_DUEDATE', label:'Date Due'},
                            {key:'uiY_SYSTEM', label:'System'},
                            {key:'uiY_FULLCODE', label:'Full Code'},
                            {key:'uiY_DESC', label:'Description'},
                            {key:'uiY_NOTES', label:'Notes'},  
                            {key:'fullname', label:'Associate'},
                            {key:'uiY_KEYWAY', label:'Keyway'},
                            {key:'hookdesc', label:'Hook Description'}
                        ]}
                        
                        defaultOrder={["uiY_DUEDATE", "uiY_SYSTEM", "uiY_FULLCODE", "uiY_DESC", "uiY_NOTES", "fullname", "uiY_KEYWAY", "hookdesc"]}

                        tableRecords = {this.props.keyData}
                        pageNumber={23}
                        tableName={'Keys'}
                        exportFileName={'keys.csv'}
                        tableData={'keyDatatableTableData'}
                        filterData={'keyDatatableFilterData'}
                        columnWidthTracker={this.state.columnWidthTracker}
                        isLoading={this.state.isLoading}
                        selectedColumns={this.state.selectedColumns}
                        handleRowClick={this.props.editRecord}
                        handleWidth={this.handleWidth}
                        handleSelectedColumns={this.handleSelectedColumns}   
                    />
                </div>
            );
        }
    }
}

export default KeyDatatable;